import { render, staticRenderFns } from "./ClinicalSupervisions.vue?vue&type=template&id=7abd1db4"
import script from "./ClinicalSupervisions.vue?vue&type=script&lang=js"
export * from "./ClinicalSupervisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports